var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-app",
    { attrs: { id: "inspire" } },
    [
      _vm.$route.path.includes("login") ||
      _vm.$route.path.includes("access-teacher") ||
      _vm.$route.path.includes("login/teacher")
        ? [
            _vm.$route.path.includes("login/teacher")
              ? _c("LoginTeacher")
              : _vm.$route.path.includes("access-teacher")
              ? _c("AccessTeacher")
              : _vm.$route.path.includes("login")
              ? _c("LoginEmail")
              : _vm._e(),
          ]
        : _c("SysCoreMaster"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }